import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as cee from '../../Common/CeeEnvisionWebComponents';
import { C3Service } from '../../c3.service';
import { FeatureEditorChild } from '../feature-editor/feature-editor.component';

@Component({
    selector: 'app-scalar-settings-editor',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './scalar-settings-editor.component.html',
    styleUrls: ['./scalar-settings-editor.component.css'],
    standalone: false
})
export class ScalarSettingsEditorComponent extends FeatureEditorChild {
  private _c3Service: C3Service;
  private _scalarSettings!: cee.ug.ScalarSettings;
  private _minScalarValue = 0;
  private _maxScalarValue = 0;

  private _colorSchemes = [
    { id: cee.ug.ColorScheme.NORMAL, name: 'Normal' },
    { id: cee.ug.ColorScheme.NORMAL_INVERTED, name: 'Inverted' },
    { id: cee.ug.ColorScheme.BLACK_TO_WHITE, name: 'Black to White' },
    { id: cee.ug.ColorScheme.WHITE_TO_BLACK, name: 'White to Black' },
    { id: cee.ug.ColorScheme.WHITE_TO_BROWN, name: 'White to Brown' },
    { id: cee.ug.ColorScheme.GREEN_TO_BROWN, name: 'Green to Brown' },
    { id: cee.ug.ColorScheme.THERMAL_1, name: 'Thermal 1' },
    { id: cee.ug.ColorScheme.THERMAL_2, name: 'Thermal 2' },
    { id: cee.ug.ColorScheme.THERMAL_3, name: 'Thermal 3' },
    { id: cee.ug.ColorScheme.METAL_CASTING, name: 'Metal Casting' },
  ];

  public get hasScalarSettings() {
    return this._scalarSettings !== undefined;
  }
  public get colorSchemes() {
    return this._colorSchemes;
  }
  public get minScalarValue() {
    return this._minScalarValue;
  }
  public get maxScalarValue() {
    return this._maxScalarValue;
  }
  public get colorScheme() {
    return this._scalarSettings.colorScheme;
  }
  public get levelCount() {
    return this._scalarSettings.levelCount;
  }
  public get rangeMinimum() {
    return this._scalarSettings.rangeMinimum;
  }
  public get rangeMaximum() {
    return this._scalarSettings.rangeMaximum;
  }
  public get autoScale() {
    return this._scalarSettings.isAutoRangeEnabled;
  }
  public get logarithmicMapping() {
    return this._scalarSettings.logarithmicMapping;
  }
  public get nodeAveragedValues() {
    return this._scalarSettings.nodeAveragedValues;
  }

  public constructor(c3Service: C3Service) {
    super();
    this._c3Service = c3Service;
    this._c3Service._viewer['0'].setColorLegendClickHandler((resultId: number) => {
      this.show();
      this.setSelectedId(resultId);
    });
  }

  public getScalarSettings = () => {
    return this._c3Service._model['0'].modelDirectory.scalarResultArray;
  };

  public scalarSettingsIdChanged(id: number) {
    this._scalarSettings = id !== undefined ? this._c3Service._model['0'].getScalarSettingsById(id) : undefined;
    this.updateMinAndMaxIsoValues();
  }

  public colorSchemeChanged(value: string) {
    this._scalarSettings.colorScheme = parseInt(value);
  }

  public levelCountChanged(value: number) {
    this._scalarSettings.levelCount = value;
  }

  public rangeMinimumChanged(value: number) {
    this._scalarSettings.setRange(value, this.rangeMaximum);
  }

  public rangeMaximumChanged(value: number) {
    this._scalarSettings.setRange(this.rangeMinimum, value);
  }

  public autoScaleChanged(value: boolean) {
    if (value) {
      this._scalarSettings.setAutoRange(cee.ug.AutoRangeMode.ALL_ITEMS);
    } else {
      this._scalarSettings.setRange(this._minScalarValue, this._maxScalarValue);
    }
  }

  public logarithmicMappingChanged(value: boolean) {
    this._scalarSettings.logarithmicMapping = value;
  }

  public nodeAveragedValuesChanged(value: boolean) {
    this._scalarSettings.nodeAveragedValues = value;
  }

  private updateMinAndMaxIsoValues() {
    if (this._scalarSettings) {
      // this._minScalarValue = this._c3Service.model.getScalarResultMinimumValue(this._scalarSettings.resultId);
      this._minScalarValue =
        (this._c3Service.model.getScalarResultMinimumValue(this._scalarSettings.resultId) +
          this._c3Service.model.getScalarResultMaximumValue(this._scalarSettings.resultId)) /
        2;

      this._maxScalarValue = this._c3Service.model.getScalarResultMaximumValue(this._scalarSettings.resultId);
    }
  }
}
